import React from 'react';
import ContentLoader, {IContentLoaderProps} from 'react-content-loader';

const UsefulInformationLoader = (props: IContentLoaderProps) => (
    <ContentLoader
        speed={2}
        width={'100%'}
        height={'100%'}
        viewBox="0 0 480 380"
        backgroundColor="#ececec"
        foregroundColor="#d6d6d6"
        {...props}>
        <rect x="0" y="17" rx="20" ry="20" width="100%" height="250" />
        <rect x="0" y="279" rx="2" ry="2" width="275" height="15" />
        <rect x="0" y="303" rx="2" ry="2" width="140" height="15" />
    </ContentLoader>
);

export default UsefulInformationLoader;
